import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingCart, Menu, X, Phone } from "lucide-react";
import { useCart } from "@/context/CartContext";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/solutions", label: "Solutions" },
  { to: "/shop", label: "Shop" },
  { to: "/request-quote", label: "Request Quote" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { count } = useCart();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-msr-line" data-testid="site-header">
      <div className="bg-msr-ink text-white text-xs">
        <div className="msr-container flex items-center justify-between py-2">
          <span className="hidden sm:block tracking-wide">MSR Business Solutions Corp. — Enterprise Software, Hardware & Infrastructure</span>
          <a href="tel:+639989693232" className="inline-flex items-center gap-1.5 hover:text-msr-green-light" data-testid="header-phone-link">
            <Phone size={12} /> +63 998 969 3232
          </a>
        </div>
      </div>

      <div className="msr-container flex items-center justify-between h-24">
        <Link to="/" className="flex items-center" data-testid="header-logo-link">
          <img src="/brand/msr-logo.png" alt="MSR Business Solutions" className="h-16 lg:h-20 w-auto object-contain" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-semibold tracking-wide transition-colors ${
                  isActive ? "text-msr-blue" : "text-msr-ink hover:text-msr-blue"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link to="/cart" className="relative inline-flex items-center gap-2 px-3 py-2 text-msr-ink hover:text-msr-blue" data-testid="header-cart-link">
            <ShoppingCart size={20} />
            {count > 0 && (
              <span className="absolute -top-1 -right-1 h-5 min-w-[20px] px-1 bg-msr-green text-white text-[10px] font-bold grid place-items-center">{count}</span>
            )}
          </Link>
          <button
            type="button"
            onClick={() => navigate("/request-quote")}
            className="hidden md:inline-flex btn-msr-primary py-2.5 px-4 text-xs"
            data-testid="header-request-quote-btn"
          >
            Request Quote
          </button>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 text-msr-ink"
            data-testid="header-mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-msr-line bg-white" data-testid="mobile-nav">
          <div className="msr-container py-3 flex flex-col">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm font-semibold border-b border-msr-line ${
                    isActive ? "text-msr-blue" : "text-msr-ink"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
